import {Box, Flex, Text, VStack} from '@chakra-ui/react';
import {useIsHomepage} from 'hooks';
import React, {FC, useEffect, useState} from 'react';
import {IRestaurantResponse, ProviderTypeEnum} from 'types';

import MetroCategoryMenu from '../../../../metro/components/categories/MetroCategoryMenu';
import {MetroLogo} from '../../../../metro/components/MetroLogo';
import {IMetroCategory} from '../../../../metro/types';
import {Logo} from '../../../logo';
import {Search} from '../search';
import {SelectAddress} from '../select-address';
import {SidebarMobileMenu} from '../sidebar-mobile-menu';

interface IProps {
  isDesktop: boolean;
  shouldHideSearch: boolean;
  providerType?: ProviderTypeEnum;
  providerName?: string;
  provider?: IRestaurantResponse;
  isMetro?: boolean;
  categories?: IMetroCategory[];
}

export const HeaderMobile: FC<IProps> = ({
  isDesktop,
  shouldHideSearch,
  providerName,
  providerType,
  provider,
  isMetro,
  categories,
}) => {
  const [lastScrollY, setLastScrollY] = useState(0);
  const isFromHomePage = useIsHomepage();

  useEffect(() => {
    if (!isFromHomePage || isDesktop) return;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const header = document.getElementById('headerContainer');

      if (header) {
        if (currentScrollY > 60 && currentScrollY > lastScrollY) {
          header.style.transition = 'transform 0.3s ease-in-out';
          header.style.transform = 'translateY(-100%)';
        } else {
          header.style.transition = 'transform 0.3s ease-in-out';
          header.style.transform = 'translateY(0)';
        }
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isDesktop, isFromHomePage, lastScrollY]);

  return (
    <VStack w="100%" justifyContent="space-around" alignItems="center">
      <Flex justifyContent="space-between" w="full">
        <Logo isDesktop={isDesktop} />
        {isMetro && (
          <>
            <Flex alignItems="center">
              <Box display="flex">
                <Text pr="5px">x</Text>
                <MetroLogo isDesktop={isDesktop} />
              </Box>
            </Flex>
          </>
        )}
        <Box ml="10px" w={isMetro ? '40%' : '80%'}>
          <SelectAddress />
        </Box>
        <SidebarMobileMenu />
      </Flex>
      {!shouldHideSearch && (
        <Box w={['full', '360px']} display="flex" alignItems="center" gap={4}>
          {isMetro && <MetroCategoryMenu categories={categories} />}
          <Box w="full">
            <Search providerType={providerType} providerName={providerName} provider={provider} isMetro={isMetro} />
          </Box>
        </Box>
      )}
    </VStack>
  );
};
